import React, { useCallback, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { POAType } from 'utils/types/navigation';
import Choices from 'design-system/Choices';
import { useCommonInvestStyles } from './styles';
import { KYCDocumentType } from '../types';
import { useAmplitudeOnMountEvent } from '../utils/analytics';
const choices = [
    'Utility bill or statement',
    'Personal bank account statement',
    'Full UK photocard driving licence',
    'HMRC correspondence that includes your National Insurance number',
    'DWP correspondence that includes your National Insurance number',
];
const ChooseProofOfAddressScreen = withAnimatedNavigationHeader(({ route, navigation, scrollHandler }) => {
    const flow = route.params?.flow;
    const address = route.params?.address;
    const commonStyles = useCommonInvestStyles();
    const documentType = useAppSelector((state) => state.invest.kycDocumentType);
    const isKYCDocLicence = documentType === KYCDocumentType.DRIVING_LICENCE || documentType === KYCDocumentType.PROVISIONAL_DRIVING_LICENCE;
    useAmplitudeOnMountEvent(flow, 'User Upload POA Screen');
    const finalChoices = useMemo(() => {
        if (isKYCDocLicence) {
            return choices.filter((choice) => choice !== 'Full UK photocard driving licence');
        }
        return choices;
    }, [isKYCDocLicence]);
    const onDone = useCallback((choice) => {
        switch (choice) {
            case 'Utility bill or statement':
                navigation.navigateDeprecated('InvestProofOfAddress', { flow, address, poaType: POAType.BILL });
                break;
            case 'Personal bank account statement':
                navigation.navigateDeprecated('InvestProofOfAddress', {
                    flow,
                    address,
                    poaType: POAType.ACCOUNT_STATEMENT,
                });
                break;
            case 'Full UK photocard driving licence':
                navigation.navigateDeprecated('InvestProofOfAddress', { flow, address, poaType: POAType.DRIVING_LICENCE });
                break;
            case 'HMRC correspondence that includes your National Insurance number':
                navigation.navigateDeprecated('InvestProofOfAddress', { flow, address, poaType: POAType.HMRC_INSURANCE });
                break;
            case 'DWP correspondence that includes your National Insurance number':
                navigation.navigateDeprecated('InvestProofOfAddress', { flow, address, poaType: POAType.DWP_INSURANCE });
                break;
            default:
                break;
        }
    }, [address, flow]);
    return (<AppView withFrame={false}>
        <View style={commonStyles.containerNoPaddingTransparent}>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={commonStyles.contentContainerWithBottomSafeArea}>
            <ScreenInfoHeader smallSubTitle preTitle="Proof of address" title="Choose a document" subTitle="Select one of the following:"/>
            <View style={styles.horizontalPadding}>
              <Choices data={finalChoices} onSelect={onDone}/>
            </View>
          </Animated.ScrollView>
        </View>
      </AppView>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: 'Proof of Address',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    rightArrowContainer: {
        marginLeft: rem(24),
        marginRight: rem(8),
    },
    horizontalPadding: {
        paddingHorizontal: rem(16),
    },
});
export default ChooseProofOfAddressScreen;
